"use strict";

import dispatcher from "./../dispatcher";
import lang from "vwa/lang";
import {pointToLatLng} from "./geo";
import {getUnitAssignment} from "./user";
import createWellQuantity from "vwa/quantity/createWellQuantity";
import vehicleActivityStore from "./../store/vehicleActivities";
import displayedDetailsStore from "./../store/displayedDetails";
import openedDetailsStore from "./../store/openedDetails";

export default {
	getPinStatusOfSection,
	getVisibilityOfActivity,
	getLatLngOfVehicleRoutesByTime,
	createPathFromInterval,
	getBoundsOfVehicleActivity,
	focusOnVehicleActivity,
	getResolvedVehicleActivity,
	getSpeedBeforeIndex,
	createRouteFromSection,
	getActiveSectionNumberOfSectionIndex
};

export {getPinStatusOfSection as getPinStatusOfSection}
export {getVisibilityOfActivity as getVisibilityOfActivity};
export {getLatLngOfVehicleRoutesByTime as getLatLngOfVehicleRoutesByTime};
export {createPathFromInterval as createPathFromInterval};
export {getBoundsOfVehicleActivity as getBoundsOfVehicleActivity};
export {focusOnVehicleActivity as focusOnVehicleActivity};
export {getResolvedVehicleActivity as getResolvedVehicleActivity}
export {getSpeedBeforeIndex as getSpeedBeforeIndex}
export {createRouteFromSection as createRouteFromSection}
export {getActiveSectionNumberOfSectionIndex as getActiveSectionNumberOfSectionIndex}

import {positionToLatLng} from "./geo";

function getPinStatusOfSection(vehicleId, sectionIndex) {
	const descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor)
		return false;
	if (descriptor.pinnedSections[sectionIndex] === undefined)
		return false;
	return descriptor.pinnedSections[sectionIndex] || false;
}

function getVisibilityOfActivity(vehicleId) {
	const displayedDetails = displayedDetailsStore.get();
	const descriptor = openedDetailsStore.get(vehicleId);
	if (!displayedDetails || !descriptor)
		return false;
	if (displayedDetails.id == vehicleId && descriptor.activePage == "activity")
		return true;
	return false;
}

function getLatLngOfVehicleRoutesByTime(vehicleId, time) {
	const activityDescriptor = vehicleActivityStore.get(vehicleId);
	if(!activityDescriptor || !activityDescriptor.routes){
		return null;
	}
	
	const routes = activityDescriptor.routes;

	//route, amiben benne van az időpont
	const route = routes.find(
		route => route.length && route[0].time <= time && route[route.length-1].time >= time
	);
	
	if(!route){
		return null;
	}
	
	const position = route.find(
		e => e.time == time
	);
	
	if(!position){
		return null;
	}
	
	return new google.maps.LatLng(position.point.coordinates[1], position.point.coordinates[0]);
}

function createPathFromInterval(vehicleId, from, to) {
	const descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor)
		return null;
	
	const routes = descriptor.routes;
	
	const path = [];
	
	routes.forEach(
		route => {
			//csak akkor nézzük meg a szakasz koordinátáit, ha a szakasz valamely része benne van a from-to intervallumban
			if(route.length && ((route[0].time >= from && route[0].time <= to) || (route[route.length-1].time <= to || route[route.length-1].time >= to))){
				route.forEach(
					position => {
						if(position.time >= from && position.time <= to){
							path.push(positionToLatLng(position));
						}
					}
				)
			}
		}
	);
	
	return path;
}

function getBoundsOfVehicleActivity(vehicleId, from, to) {
	const path = createPathFromInterval(vehicleId, from, to);
	if (!path || path.length == 0)
		return null;
	const bounds = new google.maps.LatLngBounds();
	path.forEach(latLng => bounds.extend(latLng));
	return bounds;
}

function focusOnVehicleActivity(vehicleId, from, to) {
	
	if (!getVisibilityOfActivity(vehicleId))
		return;
	
	const descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor)
		return;
	
	from = from || descriptor.from;
	to = to || descriptor.to;
	
	const bounds = getBoundsOfVehicleActivity(vehicleId, from, to);
	if (!bounds || bounds.isEmpty())
		return;

	dispatcher.dispatch("setMap", {
		bounds: bounds.toJSON()
	});
}

function getFormatedTime(time) {
	const timeDiffHours = parseInt(time / 1000 / 60 / 60);
	const timeDiffMinutes = parseInt((time / 1000 / 60) % 60);
	return (timeDiffHours > 0 ? timeDiffHours + " h " : "") + timeDiffMinutes + " m";
}

function getDataString(data, application, representationType) {
	const wellQuantity = createWellQuantity(
		getUnitAssignment(),
		application,
		data.value,
		data.unit,
		representationType
	);
	return `${wellQuantity.value} ${wellQuantity.unit}`;
}

function getResolvedSection(rawSection) {
	return {
		start: {
			address:	rawSection.start.address || lang.UNKNOWN,
			time:		new Date(rawSection.start.time.value),
			position:	rawSection.start.position && rawSection.start.position.value ? pointToLatLng(rawSection.start.position.value).toJSON() : null,
			totalVehicleDistance:	getDataString(rawSection.start.totalVehicleDistance, "distanceTraveled", "Float"),
			truncated:	rawSection.start.truncated
		},
		end: {
			address:	rawSection.end.address || lang.UNKNOWN,
			time:		new Date(rawSection.end.time.value),
			position:	rawSection.end.position && rawSection.end.position.value ? pointToLatLng(rawSection.end.position.value).toJSON() : null,
			totalVehicleDistance:	getDataString(rawSection.end.totalVehicleDistance, "distanceTraveled", "Float"),
			truncated:	rawSection.end.truncated
		},
		avgSpeed:		getDataString(rawSection.avgSpeed, "vehicleSpeed", "Integer"),
		maxSpeed:		getDataString(rawSection.maxSpeed, "vehicleSpeed", "Integer"),
		totalVehicleDistanceDiff:	getDataString(rawSection.totalVehicleDistanceDiff, "distanceTraveled", "Float"),
		timeDiff:		getFormatedTime(rawSection.timeDiff.value),
		active:			rawSection.active || false,
		truncated:		rawSection.truncated || false
	};
}

function getResolvedVehicleActivity(vehicleId) {
	const descriptor = vehicleActivityStore.get(vehicleId);
	if (!descriptor)
		return null;
	
	return {
		summary:	getResolvedSection(descriptor.summary),
		sections:	descriptor.sections.map(getResolvedSection)
	};
}

function getSpeedBeforeIndex(section, index){
	const avgSpeedTypeId = dataTypeStore.get("AvgSpeed")._id;
	
	for(let i = index; i > 0; i--){
		if(section.data[i].dataType == avgSpeedTypeId){
			return section.data[i].value;
		}
	}
	
	return 0;
}

function iirFilterRoute(route, a){
	
	let result = new Array(route.length);
	result[0] = {
		speed: route[0].speed,
		time: route[0].time,
		point: route[0].point
	};

	for(let i = 1; i < route.length; ++i) {

		let timeDiff = (route[i].time - route[i-1].time) / 1000;
		if(timeDiff < 1) {
			timeDiff = 1;
		}
		let actualAParam = Math.pow(a, (1 / timeDiff));

		result[i] = {
			speed: (actualAParam * route[i].speed) + ((1 - actualAParam) * result[i-1].speed),
			time: route[i].time,
			point: route[i].point
		};
	}
	
	return result;
}

function createRouteFromSection(section) {
	const positionTypeId = dataTypeStore.get("Position")._id;
	
	let route = [];
	
	section.data.forEach((e, i) => {
		if(e.dataType == positionTypeId){
			route.push({time: e.time, point: e.point, speed: getSpeedBeforeIndex(section, i)});
		}
	});
	
	if(route.length > 0){
		for(let i=0; i<3; i++){
			route = iirFilterRoute(route, 0.04);
		}
	}
	
	return route;
}

function getActiveSectionNumberOfSectionIndex(vehicleId, sectionIndex){
	const sections = vehicleActivityStore.get(vehicleId).sections;
	
	if(!sections[sectionIndex].active){
		return null;
	}
	
	let sectionNumber = 1;
	
	sections.forEach((section, index) => {
		if(index < sectionIndex && section.active){
			sectionNumber++;
		}
	});
	
	return sectionNumber;
}


// WEBPACK FOOTER //
// ./src/utils/vehicleActivity.js